import { render, staticRenderFns } from "./UiReport.vue?vue&type=template&id=467ed796&"
import script from "./UiReport.vue?vue&type=script&lang=js&"
export * from "./UiReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports